export enum CountryCode {
  AE = '+971',
  IN = '+91',
  QA = '+974',
  SA = '+966',
  BH = '+973',
  KW = '+965',
  OM = '+968',
  US = '+1',
}

export enum CountryGroup {
  AE = 'ae',
  IN = 'in',
  QA = 'qa',
  SA = 'sa',
  BH = 'bh',
  KW = 'kw',
  OM = 'om',
  US = 'us',
}

export enum AuthHelpCameFrom {
  LANDING = 'landing',
  LOGIN = 'login',
  MARKETING = 'marketing',
}

export enum AUTH_STATE {
  otp = 'OTP',
  login = 'LOGIN',
  profile = 'PROFILE',
}

export enum UserType {
  Free = 'Free',
  Demo = 'Demo',
  Master = 'Master',
}

export enum ServerAnalyticsPlatform {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB = 'WEB',
}

export enum ServerAnalyticsSource {
  BLP = 'BLP',
  MLP = 'MLP',
  DASHBOARD = 'DASHBOARD',
  APP = 'APP',
  PW_LEADS = 'PW_LEADS',
  LOGIN = 'LOGIN',
  FORM = 'FORM',
}
